<style lang="scss" scoped></style>

<template>
  <!-- eslint-disable max-len -->
  <div class="theme-color-wrapper p-2 booking-slots-page">
    <div class="calls row">
      <section class="col-12">
        <h2 cy="page-title" class="font-weight-bolderer mb-2">Add new booking Slot</h2>
        <router-link :to="{ name: 'social-booking-slots'}" class="body-text">
          &laquo; Go Back to view all booking slots
        </router-link>
      </section>
    </div>

    <div v-if="!loading" class="row my-2">
      <div class="slot-stage-wrapper">
        <div class="col-12">

          <section class="pb-2">
            <h4>Visit Location</h4>
            <p>Each slot needs a location, please select one from below.</p>
            <b-form-select
              id="visit-locations"
              v-model="bookingSlotToCreate.visit_location_id"
              class="mb-1"
              :disabled="visitLocations.length <= 0 || loading"
            >
              <b-form-select-option v-for="item in visitLocations" :key="item._id" :value="item._id">
                {{ item.name }}
              </b-form-select-option>
            </b-form-select>
            <div v-if="visitLocations.length <= 0" class="mb-1">
              <strong style="color: red">
                You must create a social visit location first.
              </strong>
              <router-link :to="{ name: 'visit-locations' }">
                Click here to create a visit location
              </router-link>
            </div>
          </section>

          <section class="slot-stage">
            <h4 class="pb-1">What time should the slot start?</h4>
            <div class="clock-custom d-flex" style="font-size: 18pt" cy="start-time">
              <div>
                <i class="fas fa-chevron-up d-block"
                   @click="increaseTimeSlot('slotBeginHour', hours, updateEndSlot)"
                />
                <span class="d-block">{{ bookingSlotToCreate.slotBeginHour }} :</span>
                <i class="fas fa-chevron-down d-block"
                   @click="decreaseTimeSlot('slotBeginHour', hours, updateEndSlot)"
                />
              </div>

              <div class="ml-1">
                <i class="fas fa-chevron-up d-block" @click="increaseTimeSlot('slotBeginMin', mins, updateEndSlot)" />
                <span class="d-block">{{ bookingSlotToCreate.slotBeginMin }}</span>
                <i class="fas fa-chevron-down d-block"
                   @click="decreaseTimeSlot('slotBeginMin', mins, updateEndSlot)"
                />
              </div>
            </div>

            <p class="pb-2 mt-2 font-weight-bolder">
              This slot will start at:
              <b>{{ bookingSlotToCreate.slotBeginHour }}:{{ bookingSlotToCreate.slotBeginMin }}</b>
            </p>
          </section>

          <section class="slot-stage">
            <h4 class="pb-2">What time should the slot end?</h4>

            <b-alert v-if="!endDateValid" show variant="danger" class="font-weight-bolder p-2">
              <i class="fas fa-exclamation-triangle mr-2"></i>Please ensure the end time is after the start time.
            </b-alert>

            <div class="clock-custom d-flex" style="font-size: 18pt" cy="end-time">
              <div>
                <i class="fas fa-chevron-up d-block"
                   @click="increaseTimeSlot('slotEndHour', hours, checkEndSlotValid)"
                />
                <span class="d-block">{{ bookingSlotToCreate.slotEndHour }} :</span>
                <i class="fas fa-chevron-down d-block"
                   @click="decreaseTimeSlot('slotEndHour', hours, checkEndSlotValid)"
                />
              </div>

              <div class="ml-1">
                <i class="fas fa-chevron-up d-block"
                   @click="increaseTimeSlot('slotEndMin', mins, checkEndSlotValid)"
                />
                <span class="d-block">{{ bookingSlotToCreate.slotEndMin }}</span>
                <i class="fas fa-chevron-down d-block"
                   @click="decreaseTimeSlot('slotEndMin', mins, checkEndSlotValid)"
                />
              </div>
            </div>

            <p class="pb-2 mt-2 font-weight-bolder" cy="slot-text">
              This slot will start at:
              <b>{{ bookingSlotToCreate.slotBeginHour }}:{{ bookingSlotToCreate.slotBeginMin }}</b>
              <span style="margin-left: 5px" class="d-inline-block">
                and end at: <b>{{ bookingSlotToCreate.slotEndHour }}:{{ bookingSlotToCreate.slotEndMin }}</b></span>
            </p>
          </section>

          <section class="slot-stage">
            <h4 class="pb-2">When should this slot be offered?</h4>
            <p>Choose all the days that apply</p>
            <div>
              <label v-for="(weekDay, index) in weekDays" :key="index" class="d-block font-weight-bolder" style="font-size: 1rem">
                <input v-model="selectedWeekdays" :cy="weekDay" :value="weekDay" type="checkbox" class="mr-1">
                {{ weekDay }}
              </label>
            </div>
          </section>

          <section class="slot-stage">
            <h4 class="pb-2 pt-2">Do you want to apply a date range?</h4>

            <b-form-checkbox v-model="applyDateRange" name="check-button" switch @change="resetStartEndDate()">
              Apply date range
            </b-form-checkbox>

            <section v-if="applyDateRange">
              <p class="pt-3">Select a start and end date</p>
              <div>
                <label>Start Date</label>
                <b-form-datepicker
                  v-model="bookingSlotToCreate.start_date"
                  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                  @input="bookingSlotToCreate.end_date = ''"
                />
                <label>End Date</label>
                <b-form-datepicker
                  v-model="bookingSlotToCreate.end_date"
                  :min="bookingSlotToCreate.start_date"
                  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                />
              </div>
            </section>

          </section>

          <section class="slot-stage">
            <button
              :disabled="!validCreate()"
              class="btn btn-block btn-success mt-2"
              @click="createBookingSlots()"
            >
              Add new booking slot (this will make the slot available for bookings)
            </button>
          </section>
        </div>
      </div>
    </div>

    <div v-else class="mt-1">
      <b-spinner class="d-block" variant="primary" />
    </div>
  </div>
  <!-- eslint-enable -->
</template>

<script>
import moment from 'moment';
import SocialBookingSlotService from '@/services/SocialBookingSlotsService';
import { ERROR_CODES } from '@/util/errorCodes';
import { mapState } from 'vuex';
import VisitLocationsService from '@/services/VisitLocationsService';

export default {
  name: 'CreateBookingSlot',
  data() {
    return {
      bookingSlotToCreate: {
        name: '',
        weekDay: 'Monday',
        slotBeginHour: '09',
        slotBeginMin: '00',
        slotEndHour: '09',
        slotEndMin: '30',
        active: 'active',
        start_date: '',
        end_date: '',
        visit_location_id: '',
      },
      selectedWeekdays: [],
      weekDays: SocialBookingSlotService.getWeekdays(),
      hours: SocialBookingSlotService.getHours(),
      mins: SocialBookingSlotService.getMinutes(),
      stage: 2,
      slotsToCreate: [],
      endDateValid: true,
      loading: true,
      applyTableCount: false,
      applyDateRange: false,
      visitLocations: [],
    };
  },
  computed: mapState({
    prison: state => state.prison.prison,
    allBookingSlots: state => state.socialBookingSlots.bookingSlots,
  }),
  async mounted() {
    await this.$store.dispatch('prison/getPrison');
    await this.getVisitLocations();
    this.loading = false;
    await this.$store.dispatch('socialBookingSlots/getBookingSlots');
  },
  methods: {
    setStage(num) {
      this.stage = num;
    },
    validCreate() {
      const valid = this.selectedWeekdays.length > 0 && this.endDateValid && this.bookingSlotToCreate.visit_location_id;
      const startDate = this.bookingSlotToCreate.start_date.length > 0;

      if (this.applyDateRange) {
        return startDate && valid;
      }
      return valid;
    },
    async getVisitLocations() {
      try {
        const response = await VisitLocationsService.getVisitLocationsForPrison();
        this.visitLocations = response.data;
      } catch (e) {
        console.error('Error getting visit locations');
        this.$toast.error('Error getting visit locations', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      }
    },
    createBookingSlots() {
      const bc = this.bookingSlotToCreate;
      console.log('>>> visitLocationId before: ', bc.visit_location_id);
      let duplicateSlots = [];
      const vm = this;

      // Loop through selected days to get duplicated slots and create new ones
      this.selectedWeekdays.forEach(day => {
        const slotBegin = `${bc.slotBeginHour}:${bc.slotBeginMin}`;
        const slotEnd = `${bc.slotEndHour}:${bc.slotEndMin}`;

        duplicateSlots = duplicateSlots.concat(SocialBookingSlotService.getDuplicatedDates(
          this.allBookingSlots,
          day,
          slotBegin,
          slotEnd,
          null,
          bc.visit_location_id,
        ));
        this.slotsToCreate.push(vm.getNewSingleBookingSlot(day)); // add all weekdays
      });
      duplicateSlots = SocialBookingSlotService.filterDuplicatesByDateRange(duplicateSlots, bc);

      // this.manageUpdatingSlots(duplicateSlots[0], duplicateSlots);
      if (duplicateSlots[0]) { // warn if duplicates, otherwise create
        this.displayBookingSlotOverlapModal(duplicateSlots[0], duplicateSlots);
      } else {
        this.createNewSlotsFromWeekdays();
      }
    },
    getNewSingleBookingSlot(weekDay) {
      const start = `${this.bookingSlotToCreate.slotBeginHour}:${this.bookingSlotToCreate.slotBeginMin}`;
      const end = `${this.bookingSlotToCreate.slotEndHour}:${this.bookingSlotToCreate.slotEndMin}`;
      const name = `${weekDay} ${start} - ${end}`;

      return {
        prison_id: this.prison.prison_id,
        name: name.trim(),
        day_of_week: weekDay,
        slot_begin: start,
        slot_end: end,
        visit_location_id: this.bookingSlotToCreate.visit_location_id,
        active: this.bookingSlotToCreate.active === 'active',
        start_date: this.bookingSlotToCreate.start_date,
        end_date: this.bookingSlotToCreate.end_date,
      };
    },
    createNewSlotsFromWeekdays() {
      const promises = [];
      this.slotsToCreate.forEach(slot => {
        promises.push(SocialBookingSlotService.createBookingSlot(slot));
      });

      Promise.all(promises).then(() => {
        if (promises.length > 0) {
          this.$toast.success('Booking slots successfully created', {
            toastClassName: ['toast-std', 'success-toast'],
          });
        } else {
          this.$toast.info('No Booking slots created');
        }

        this.$router.push('/social-booking-slots');
      }).catch(err => {
        console.log('Error creating booking slots', err);
        // eslint-disable-next-line max-len
        if (err && err.response && err.response.data && err.response.data.error === ERROR_CODES.BOOKING_SLOTS.OVERLAP) {
          console.log('overlap');
        } else {
          this.$toast.error('Error creating booking slot, all previously created booking slots will remain', {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        }
      });
    },
    displayBookingSlotOverlapModal(slot, slots) {
      const name = SocialBookingSlotService.getOverlapName(slot);

      this.$swal({
        title: `This overlaps with an existing slot ${name}`,
        text: 'Do you want to overwrite the existing slot?',
        icon: 'warning',
        buttons: true,
      }).then(value => {
        if (value) { // if yes add new created slot
          // delete overlap
          const slotClone = { ...slot };
          slotClone.active = false;
          SocialBookingSlotService.updateBookingSlot(slotClone._id, slotClone).then(() => {
            this.manageUpdatingSlots(slot, slots);
          }).catch(err => {
            console.log('Error deleting booking slot ', err);
            // eslint-disable-next-line max-len
            if (err && err.response && err.response.data && err.response.data.error === ERROR_CODES.BOOKING_SLOTS.OVERLAP) {
              this.$toast.error('Error deleting the booking slot, booking slot overlaps', {
                toastClassName: ['toast-std', 'warning-toast'],
              });
            } else {
              this.$toast.error('Error deleting the booking slot', {
                toastClassName: ['toast-std', 'warning-toast'],
              });
            }
          });
        } else {
          this.removeDayFromSlotsToCreate(slot.day_of_week); // remove slot from booking create
          this.manageUpdatingSlots(slot, slots);
        }
      });
    },
    manageUpdatingSlots(slot, slots) {
      const newSlots = slots.splice(1); // remove the first slot

      if (newSlots[0]) {
        this.displayBookingSlotOverlapModal(newSlots[0], newSlots);
      } else { // finished update all slots
        this.createNewSlotsFromWeekdays();
      }
    },
    removeDayFromSlotsToCreate(day) {
      this.slotsToCreate = this.slotsToCreate.filter(slot => slot.day_of_week !== day);
    },
    updateEndSlot() {
      this.checkEndSlotValid();
    },
    checkEndSlotValid() {
      let startTime = `${this.bookingSlotToCreate.slotBeginHour}:${this.bookingSlotToCreate.slotBeginMin}:00`;
      let endTime = `${this.bookingSlotToCreate.slotEndHour}:${this.bookingSlotToCreate.slotEndMin}:00`;

      startTime = moment(startTime, 'HH:mm:ss');
      endTime = moment(endTime, 'HH:mm:ss');

      const duration = moment.duration(endTime.diff(startTime));
      const minutesLeft = duration.asMinutes();

      const negative = Math.sign(minutesLeft) === -1;

      this.endDateValid = !negative;
    },
    increaseTimeSlot(prop, array, callback) {
      const value = this.bookingSlotToCreate[prop];
      const max = array.length - 1;
      const index = array.indexOf(value);

      if (index < max) {
        this.bookingSlotToCreate[prop] = array[index + 1]; // first element
      } else {
        this.bookingSlotToCreate[prop] = array[0];
      }

      if (callback) {
        callback();
      }
    },
    decreaseTimeSlot(prop, array, callback) {
      const value = this.bookingSlotToCreate[prop];
      const max = array.length - 1;
      const index = array.indexOf(value);

      if (index === 0) {
        this.bookingSlotToCreate[prop] = array[max]; // first element
      } else {
        this.bookingSlotToCreate[prop] = array[index - 1];
      }

      if (callback) {
        callback();
      }
    },
    resetStartEndDate() {
      this.start_date = '';
      this.end_date = '';
    },

  },
};
</script>
